import React, { useEffect, useState } from "react";
import { TextComponent } from "../../../../components";
import styles from "./Profile.module.css";
import placeholder from "../../../../assets/dummy.jpg";
import { FiEdit } from "react-icons/fi";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { phoneFormat } from "../../../../utills";
import { FaFacebookF, FaGoogle, FaInstagram } from "react-icons/fa";
import { ImInstagram } from "react-icons/im";
import { AiOutlineTwitter } from "react-icons/ai";
import { TbWorld } from "react-icons/tb";
import { FaXTwitter } from "react-icons/fa6";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const Profile = () => {
  // const role = localStorage.getItem("role");
  const dispatch = useDispatch();
  const [isCopied, setIsCopied] = useState(false);
  const role = Storage.getERole("@role");
  const user = useSelector((state) => state.AuthReducer.user);

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
  }, []);
  console.log("user", user);

  const navigate = useNavigate();
  const data = [
    {
      name: "Date of Birth",
      info: user?.dob ? moment(user?.dob).format("MMM DD YYYY") : "--",
    },
    {
      name: "Contact No.",
      info: user?.contact_no ? phoneFormat(user?.contact_no) : "--",
    },
    {
      name: "Address",
      info: user?.address ? user?.address : "--",
    },
    {
      name: "Gender",
      info: user?.gender ? user?.gender : "--",
    },
  ];

  if (role == roles.vendor || role == roles.staff) {
    data.splice(0, 1);
    data.splice(2, 1);
    data.push({
      name: "Socials",
      links: user?.sociallink ? user?.sociallink : "--",
    });
  }
  // async function copyTextToClipboard(text) {
  //   if ("clipboard" in navigator) {
  //     return await navigator.clipboard.writeText(text);
  //   }
  // }
  // const handleCopyClick = (link) => {
  //   copyTextToClipboard(link)
  //     .then(() => {
  //       dispatch(showAlert({
  //         type: "Success",
  //         message: "Copied"
  //       }))
  //       // If successful, update the isCopied state value
  //       setIsCopied(true);
  //       // setIsCopyModalOpen(false)
  //       setTimeout(() => {
  //         setIsCopied(false);
  //       }, 1500);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const renderItem = (item) => (
    // console.log("iteeeeeeeemmmmmmmm", item),
    <div className={styles.option_tab_view}>
      <div className={styles.option_tab}>
        <TextComponent text={item?.name} textClass={styles.text} />
      </div>
      {item?.links?.length > 0 ? (
        <div className={styles.detailCont}>
          {item?.links?.map((text, index) => (
            <div key={text?.link}>
              {/* <h1>{text?.link}</h1> */}
              <a
                href={text?.link}
                target="_blank"
                className={styles.socialIcons}
              >
                {/* <div className={styles.socialIcons}
                 onClick={()=>handleCopyClick(text?.link)}
                 > */}
                {text?.link.includes("google") ? (
                  <FaGoogle />
                ) : text?.link.includes("facebook") ? (
                  <FaFacebookF />
                ) : text?.link.includes("instagram") ? (
                  <FaInstagram />
                ) : text?.link.includes("twitter") ? (
                  <FaXTwitter />
                ) : (
                  <TbWorld />
                )}
                {/* </div> */}
                {/* <TextComponent text={text?.link} textClass={styles.textsocial} /> */}
              </a>
            </div>
          ))}
        </div>
      ) : (
        <TextComponent text={item?.info} textClass={styles.textx} />
      )}
    </div>
  );

  return (
    <>
      {role == roles.vendor && (
        <TextComponent
          textClass={styles.headingText}
          text={"Personal Information"}
        />
      )}

      <div className={styles.main_box}>
        <div className={styles.initial_box}>
          <div className={styles.profile_image_view}>
            <img
              src={user?.image ? user?.image : placeholder}
              className={styles.profile_image}
            />
          </div>

          <TextComponent
            text={`${user?.first_name} ${user?.last_name}`}
            textClass={styles.heading}
          />
          <TextComponent text={user?.email} textClass={styles.sub_heading} />

          <button
            onClick={() => navigate("/editProfile")}
            className={styles.edit_button}
          >
            <FiEdit className={styles.icon} />
            <TextComponent textClass={styles.button_text}>
              Edit Profile
            </TextComponent>
          </button>
        </div>

        <div className={styles.next_box}>
          <div className={styles.options_bar}>
            <div className={styles.options_inner_bar}>
              {/* <List dataSource={data} renderItem={renderItem} /> */}
            </div>
          </div>
          <div style={{ marginLeft: -30 }}>
            <List dataSource={data} renderItem={renderItem} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
